import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    deleteDoc,
    query,
    setDoc,
    where,
    limit,
    orderBy,
    writeBatch,
} from "firebase/firestore";
import Promise from "bluebird";
import _ from "lodash";
import {fireStoreDB} from "../../firebase/client-app";

export {
    addShopifyProducts,
    batchSaveProductsList,
    updateShopifyProducts,
    updateSingleShopifyProduct,
    deleteSingleShopifyProduct,
    getSingleShopifyProduct,
    searchShopifyProducts,
    searchShopifyProductByDesignIds,
    getAllPODShopifyProducts,
    prepareShopifyProductsList
}

const collectionName = 'shopify-products';
const collectionReference = collection(fireStoreDB, collectionName);

const addShopifyProducts = (shopifyProducts) => {
    return Promise.map(shopifyProducts, async shopifyProduct => {
        console.log('.');
        await addSingleShopifyProduct(shopifyProduct);
    });
}

const updateShopifyProducts = (shopifyProducts) => {
    return Promise.map(shopifyProducts, async shopifyProduct => {
        console.log('.');
        await updateSingleShopifyProduct(shopifyProduct);
    });
}

const batchSaveProductsList = async (productList) => {
    let batch = writeBatch(fireStoreDB);
    const promises = [];
    const productsBatchList = _.chunk(productList, 100);
    // console.log({productsBatchList})

    _.forEach(productsBatchList, (products) => {
        _.forEach(products, (product: any) => {
            const docRef = doc(collectionReference, product.id);
            batch.update(docRef, product, {merge: true});
        });

        promises.push(batch.commit());
        batch = writeBatch(fireStoreDB);
    });

    await Promise.all(promises);
    return;
};

const addSingleShopifyProduct = (shopifyProduct) => {
    return addDoc(collectionReference, shopifyProduct);
}

const updateSingleShopifyProduct = (shopifyProduct) => {
    const documentReference = doc(fireStoreDB, collectionName, shopifyProduct.id);
    // console.log('Before Saving... ', {shopifyProduct})
    return setDoc(documentReference, shopifyProduct, {merge: true});
}

const deleteSingleShopifyProduct = (shopifyProduct) => {
    const documentReference = doc(fireStoreDB, collectionName, shopifyProduct.id);
    return deleteDoc(documentReference);
}

const getSingleShopifyProduct = async (shopifyProductId) => {
    const documentReference = doc(fireStoreDB, collectionName, shopifyProductId);
    const shopifyProductDoc = await getDoc(documentReference);
    return prepareSingleShopifyProduct(shopifyProductDoc);
}

const searchShopifyProducts = async (searchCriteriaList, orderByAttr?) => {
    let searchQuery = query(collectionReference);

    if (orderByAttr) {
        searchQuery = query(collectionReference, orderBy(orderByAttr, 'desc'));
    }

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    searchQuery = query(searchQuery,
        limit(30));

    const shopifyProductResult = await getDocs(searchQuery);
    return prepareShopifyProductsList(shopifyProductResult);
}

const searchShopifyProductByDesignIds = async (designIds) => {
    let searchQuery = query(collectionReference);

    searchQuery = query(searchQuery,
        where('designId', "in", designIds));

    const shopifyProductResult = await getDocs(searchQuery);
    return prepareShopifyProductsList(shopifyProductResult);
}

const getAllPODShopifyProducts = async (podId) => {
    let searchQuery = query(collectionReference,
        where("podId", "==", podId));

    const shopifyProductResult = await getDocs(searchQuery);
    return prepareShopifyProductsList(shopifyProductResult);
}

const prepareShopifyProductsList = (shopifyProductResult) => {
    const shopifyProductsList = [];

    _.forEach(shopifyProductResult.docs, shopifyProductDoc => {
        shopifyProductsList.push(prepareSingleShopifyProduct(shopifyProductDoc));
    });

    return shopifyProductsList;
}

const prepareSingleShopifyProduct = (shopifyProductDoc) => {
    const shopifyProduct = shopifyProductDoc.data();
    shopifyProduct.id = shopifyProductDoc.id;
    return shopifyProduct;
}
